import React, { useEffect, useState, memo } from 'react';
import ReactApexChart from 'react-apexcharts';
import { View } from 'react-native';
import { LinearGradient } from 'tamagui/linear-gradient';

const ApexChart = ({ chartData }) => {
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState({
    chart: {
      type: 'radialBar',
    },
    plotOptions: {
      radialBar: {
        offsetY: 0,
        startAngle: 0,
        endAngle: 270,
        hollow: {
          margin: 5,
          size: '30%',
          background: 'transparent',
          image: undefined,
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            show: false,
          },
        },
        barLabels: {
          enabled: true,
          useSeriesColors: true,
          offsetX: -8,
          fontSize: '12px',
          formatter: (seriesName, opts) => {
            return `${seriesName}:  ${opts.w.globals.series[opts.seriesIndex]}`;
          },
        },
      },
    },
    colors: ['#1ab7ea', '#0084ff', '#39539E'],
    labels: ['Seen', 'Unseen', 'Interacted'],
    max: 100,
    responsive: [
      {
        breakpoint: 400,
        options: {
          legend: {
            show: false,
          },
        },
      },
    ],
  });

  useEffect(() => {
    if (chartData) {
      const newSeries = chartData.map(item => item.population);
      const newLabels = chartData.map(item => item.name);
      const newColors = chartData.map(item => item.color);
      const newMax = Math.max(...chartData.map(item => item.limit));

      console.log('--- Chart Data Update ---');
      console.log('New Series:', newSeries);
      console.log('New Labels:', newLabels);
      console.log('New Colors:', newColors);
      console.log('New Max:', newMax);

      setSeries(newSeries);
      setOptions(prevOptions => ({
        ...prevOptions,
        labels: newLabels.length ? newLabels : prevOptions.labels,
        colors: newColors.length ? newColors : prevOptions.colors,
        max: newMax ? newMax : prevOptions.max,
      }));
    } else {
      console.log('--- Chart Data is null/undefined, setting default series ---');
      setSeries([76, 67, 61]);
    }
  }, [chartData]); // This dependency array ensures it runs when chartData changes

  return (
    <LinearGradient colors={['color2', 'rgba(90,192,234)']} style={{ paddingRight: 5, borderRadius: 20 }}>
        <ReactApexChart
          options={options}
          series={series}
          type="radialBar"
          height={290}
        />
    </LinearGradient>
  );
};

export default memo(ApexChart);
